<template>
    <KeywordSearch/>
</template>
<script>
import KeywordSearch from 'place/search/keywordSearch.vue'
export default {
    components:{
      KeywordSearch
    }
}
</script>
<style scoped>
</style>